import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { createCallbackActionCreator } from '../../Stream/helpers';
import { PapiNetworkbar } from '@wix/da-papi-types';
import { NetworkBarStreamTypes } from './types';

export const initializeNetworkBar = createAction(
  `${actionKey}/INITIALIZE`,
  (networkBarData: PapiNetworkbar) => networkBarData
);

export const initialFetch = createAction(`${actionKey}/FETCH_INITIAL`, () => ({}));

export const fetchMoreWatchedGroups = createCallbackActionCreator(
  `${actionKey}/FETCH_WATCHED_GROUPS`
);
export const fetchMoreRecommendedGroups = createCallbackActionCreator(
  `${actionKey}/FETCH_RECOMMENDED_GROUPS`
);

export const togglePinGroup = createAction(
  `${actionKey}/TOGGLE_PIN`,
  (groupId: number, isPinnedAfter: boolean) => ({
    groupId,
    isPinnedAfter,
  })
);

export const toggleWatchGroup = createAction(
  `${actionKey}/TOGGLE_WATCH`,
  (groupId: number, isWatchingAfter: boolean) => ({
    groupId,
    isWatchingAfter,
  })
);

export const unrecommendGroup = createAction(`${actionKey}/UNRECOMMEND`, (groupId: number) => ({
  groupId,
}));

export const markChannelAsRead = createAction(
  `${actionKey}/MARK_AS_READ`,
  (channel: string | number) => ({ channel })
);

/** change state and update backend */
export const updateNetworkBarSection = createAction(
  `${actionKey}/TOGGLE_SECTION`,
  (section: NetworkBarStreamTypes, isFoldedNow: boolean) => ({
    isFoldedNow,
    section,
  })
);

/** change state without updating backend */
export const setNetworkBarSection = createAction(
  `${actionKey}/SET_SECTION`,
  (section: NetworkBarStreamTypes, isFoldedNow: boolean) => ({
    isFoldedNow,
    section,
  })
);
